import {
  Component,
  Input,
  ViewChild,
  Output,
  EventEmitter,
} from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import {
  NgbModal,
  NgbModalRef,
  NgbTypeahead,
} from "@ng-bootstrap/ng-bootstrap";
import { BaseComponent } from "../base.component";
import { Base, UserTypes } from "../_models/index";
// tslint:disable-next-line:import-blacklist
import { Observable, Subject } from "rxjs";
import { merge } from "rxjs/observable/merge";
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
} from "rxjs/operators";
import * as $ from "jquery";
import * as _ from "lodash";
import { autoFillForms } from "../_helpers/auto-fill-forms/auto-fill-forms";
import { LocalStorageManagerService } from "../_services/localStoageManager.service";
import { NgForm } from "@angular/forms";
import { LocationManagerService } from "../_services/locationManager.service";
import { ParentService } from "../_services/parent.service";
import { ApprovalModalComponent } from "../common/approval-modal/approval-modal.component";
import { ApprovalModalResult } from "../common/approval-modal/approval-modal-result.enum";
import { ChildModel } from "../_models/child-model";
import { QueryParamsModel } from "../_models/query-params";
import { SessionManagerService } from "../_services/SessionManager/session-manager.service";
import { DataService } from "../_services/data.service";
import { AlertService } from "../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "createchild",
  templateUrl: "createchild.component.html",
})
export class CreateChildComponent extends BaseComponent {
  @Input() child: any;
  @Input() nest?: any;
  @Input() allBrothersData?: any;
  @Input() eventMeshutaf?: any;
  @Input() fromModal?: boolean;
  @Input() isAdditionalDataRequest?: boolean;
  //if true,means that it is from addition data,
  // no handling for children needed in the service
  @Output() childSavedAction?: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("f") childCreateForm: NgForm;
  model: any = {};
  loading = false;
  nests: any;
  countries: any;
  layers: any;
  genders: any = ["נקבה", "זכר"];
  UserTypesEnum = UserTypes;
  addedParents: any[] = [];
  removedParents: any[] = [];

  focusChild$ = new Subject<string>();
  clickChild$ = new Subject<string>();
  focusParent$ = new Subject<string>();
  clickParent$ = new Subject<string>();

  constructor(
    private router: Router,
    public dataService: DataService,
    private alertService: AlertService,
    private localStorageManagerService: LocalStorageManagerService,
    private locationManageService: LocationManagerService,
    private parentService: ParentService,
    public sessionManager: SessionManagerService,
    private modalService: NgbModal
  ) {
    super(dataService, sessionManager);
    this.nests = JSON.parse(
      this.localStorageManagerService.getItem("allNests")
    );

    if (!this.nests && this.localStorageManagerService.getItem("nests")) {
      // Shlomo: for some reason we have 'nests' and not
      // 'allNests' when parent has no children yet
      this.nests = JSON.parse(this.localStorageManagerService.getItem("nests"));
    }
    this.layers = JSON.parse(this.localStorageManagerService.getItem("layers"));
    this.countries = JSON.parse(
      this.localStorageManagerService.getItem("countries")
    );
    autoFillForms(this, { shouldSubmit: false });
  }

  countryFormatter = (country: any) => country.name;

  formatter = (x: { nestName: string }) => x.nestName;

  //TODO : replace the chained observable with a pipe()
  search = (text$: Observable<string>) =>
    text$
      .debounceTime(200)
      .distinctUntilChanged()
      .map((term) =>
        term === "" || !this.nests
          ? []
          : this.nests
              .filter(
                (v) =>
                  v.nestName &&
                  v.nestName.toLowerCase().indexOf(term.toLowerCase()) > -1
              )
              .slice(0, 10)
      );

  saveChild() {
    this.loading = true;
    const postData = this.model;
    postData.id = this.child ? this.child.id : undefined;
    if (
      this.addedParents &&
      this.addedParents.length &&
      this.addedParents.length > 0
    ) {
      postData["addedParents"] = this.addedParents;
    }
    if (
      this.removedParents &&
      this.removedParents.length &&
      this.removedParents.length > 0
    ) {
      postData["removedParents"] = this.removedParents;
    }

    this.addObservable(
      this.dataService
        .saveChild(postData, this.isAdditionalDataRequest)
        .subscribe(
          (responseData) => {
            this.loading = false;
            let offerConnectChildToBrothers = true;
            if (
              !this.sessionManager.features
                .ModalWithBrotherAttributionAfterChildSave
            ) {
              offerConnectChildToBrothers = false;
            }

            if (this.isAdditionalDataRequest) {
              this.childSavedAction.emit(postData);
            } else if (this.eventMeshutaf && this.eventMeshutaf.eventId) {
              if ($("#closeModal").length > 0) {
                $("#closeModal").click();
              }
              //@ts-ignore
              if (responseData && responseData["events"]) {
                this.dataService.events.next(responseData["events"]);
              }
            } else {
              if ($("#closeModal").length > 0) {
                $("#closeModal").click();
              }
              if (!offerConnectChildToBrothers) {
                this.locationManageService.reload();
                return;
              }
            }
            responseData.data.childId = postData.childId;
            this.openBrotherAttributionModal(responseData);
          },
          (error) => {
            let body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
            this.loading = false;
          }
        )
    );
  }

  run() {
    if (this.child && this.child.childId > 0) {
      this.model = Object.assign({}, this.child);
    }
    if (this.child && this.child.originCountryChild && this.countries) {
      let originCountryChildArr = _.filter(this.countries, {
        id: this.child.originCountryChild,
      });
      if (originCountryChildArr && originCountryChildArr.length > 0) {
        this.model.originCountryChild = originCountryChildArr[0];
      }
    }
    if (this.child && this.child.originCountryParent && this.countries) {
      let originCountryParentArr = _.filter(this.countries, {
        id: this.child.originCountryParent,
      });
      if (originCountryParentArr && originCountryParentArr.length > 0) {
        this.model.originCountryParent = originCountryParentArr[0];
      }
    }
    if (this.nest && this.nest.nestId) {
      this.model.nest = this.nest;
    }
    if (this.eventMeshutaf && this.eventMeshutaf.eventId) {
      this.model.event = this.eventMeshutaf;
    }
  }

  onParentSelect(parent) {
    if (this.child) {
      this.child.parents =
        this.child.parents &&
        this.child.parents.length &&
        this.child.parents.length > 0
          ? this.child.parents
          : [];
      let alreadyAddedParents = _.filter(this.child.parents, {
        id: parent.id,
      });
      if (
        !alreadyAddedParents ||
        !alreadyAddedParents.length ||
        alreadyAddedParents.length == 0
      ) {
        this.child.parents.push(parent);
        this.addedParents.push(parent);
      }
    } else {
      this.addedParents.push(parent);
    }
  }

  removeParentFromChild(parent) {
    if (
      parent &&
      parent.id &&
      this.child &&
      this.child.parents &&
      this.child.parents.length
    ) {
      let removedParents = _.remove(this.child.parents, {
        id: parent.id,
      });

      let amongAddedParentsArr = _.filter(this.addedParents, {
        id: parent.id,
      });
      if (
        !amongAddedParentsArr ||
        !amongAddedParentsArr.length ||
        amongAddedParentsArr.length == 0
      ) {
        this.removedParents.push(parent);
      } else {
        _.remove(this.addedParents, { id: parent.id });
      }
    } else if (!this.child) {
      _.remove(this.addedParents, { id: parent.id });
    }
  }

  onChange(event) {}

  searchCountryChild = (text$: Observable<string>) => {
    return this.searchCountry(text$, 1);
  };

  searchCountryParent = (text$: Observable<string>) => {
    return this.searchCountry(text$, 2);
  };

  searchCountry = (text$: Observable<string>, type: number) => {
    const debouncedText$ = text$.pipe(
      debounceTime(200),
      distinctUntilChanged()
    );
    // 	    const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.originCountryChildComp.isPopupOpen()));
    const inputFocus$ = type == 1 ? this.focusChild$ : this.focusParent$;

    return merge(debouncedText$, inputFocus$).pipe(
      map((term) =>
        term === ""
          ? this.countries.filter((v) => true)
          : this.countries.filter(
              (v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1
            ).length > 0
          ? this.countries.filter(
              (v) => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1
            )
          : this.countries.filter((v) => v.id == 195)
      )
    );
  };

  equals(l1: any, l2: any) {
    if (!l1 && !l2) {
      return true;
    }
    if (l1 && l1.layerId && l2 && l2.layerId) {
      return l1.layerId === l2.layerId;
    } else {
      return false;
    }
  }

  private openBrotherAttributionModal(responseData: {
    data: ChildModel;
    additionalBrothersInfo?: {
      attributedBrothers: ChildModel[];
      notAttributedBrothers: ChildModel[];
    };
  }) {
    try {
      const getBrothersNames = (brothers: ChildModel[]): string =>
        brothers
          .map((brother) => `${brother.firstName} ${brother.lastName}`)
          .join(", ");
      const chanichData = responseData.data;
      const additionalBrothersInfo = responseData.additionalBrothersInfo;
      const modalRef: NgbModalRef = this.modalService.open(
        ApprovalModalComponent
      );
      const chanichName = `${chanichData.firstName} ${chanichData.lastName}`;

      const enum ChanichSaveScenario {
        HasNoBrothers = 0,
        HasBrothersAndAllWereAttributed = 1,
        HasBrothersAndSomeWereAttributed = 2,
        HasBrothersButNoneWereAttributed = 3,
        ExistingChanichUpdate = 4,
      }

      let chanichSaveScenario = ChanichSaveScenario.HasNoBrothers;
      if (additionalBrothersInfo) {
        const attributedCount =
          additionalBrothersInfo.attributedBrothers.length;
        const notAttributedCount =
          additionalBrothersInfo.notAttributedBrothers.length;
        if (attributedCount > 0 && notAttributedCount > 0) {
          chanichSaveScenario =
            ChanichSaveScenario.HasBrothersAndSomeWereAttributed;
        }
        if (attributedCount === 0 && notAttributedCount > 0) {
          chanichSaveScenario =
            ChanichSaveScenario.HasBrothersButNoneWereAttributed;
        }
        if (attributedCount > 0 && notAttributedCount === 0) {
          chanichSaveScenario =
            ChanichSaveScenario.HasBrothersAndAllWereAttributed;
        }
      }
      if (responseData.data.childId && responseData.data.childId > 0) {
        chanichSaveScenario = ChanichSaveScenario.ExistingChanichUpdate;
      }
      const messages = this.base.messages;
      const modalInfo = {
        mainMessage: messages.save.replace("$1$", chanichName),
        approveText: messages.to_brother_discount,
        cancelText: messages.cancel,
        modalHeader: messages.brother_request_modal_header,
        hideCancelButton: false,
      };

      switch (chanichSaveScenario) {
        case ChanichSaveScenario.HasNoBrothers:
        case ChanichSaveScenario.HasBrothersAndAllWereAttributed:
          modalInfo.modalHeader = messages.save;
          modalInfo.mainMessage =
            messages.brother_request_modal_was_created_successfully.replace(
              "$1$",
              chanichName
            );
          modalInfo.approveText = messages.confirm;

          modalInfo.hideCancelButton = true;

          break;
        case ChanichSaveScenario.HasBrothersAndSomeWereAttributed:
        case ChanichSaveScenario.HasBrothersButNoneWereAttributed:
          modalInfo.mainMessage = `${messages.brother_request_modal_was_created_successfully.replace(
            "$1$",
            chanichName
          )}.
          ${messages.brother_request_modal_chanich_not_attributed_ver2.replace(
            "$1$",
            chanichName
          )}${getBrothersNames(
            additionalBrothersInfo.notAttributedBrothers
          )}, ${
            messages.brother_request_modal_would_you_like_to_make_request_ver2
          }`;
          modalInfo.approveText = messages.to_brother_discount;
          modalInfo.cancelText =
            messages.brother_request_modal_do_not_attribute_button_ver2;
          break;
        case ChanichSaveScenario.ExistingChanichUpdate:
          modalInfo.modalHeader = messages.save;
          modalInfo.mainMessage =
            messages.brother_request_modal_was_updated_successfully.replace(
              "$1$",
              chanichName
            );
          modalInfo.approveText = messages.confirm;

          modalInfo.hideCancelButton = true;
          break;
      }

      (modalRef.componentInstance as ApprovalModalComponent).info = modalInfo;

      modalRef.result.then(
        (result) => {
          if (
            chanichSaveScenario ===
              ChanichSaveScenario.HasBrothersAndAllWereAttributed ||
            chanichSaveScenario === ChanichSaveScenario.HasNoBrothers ||
            chanichSaveScenario === ChanichSaveScenario.ExistingChanichUpdate
          ) {
            this.locationManageService.reload();
          }
          if (result === ApprovalModalResult.Approve) {
            const ext: NavigationExtras = {
              queryParams: {
                [QueryParamsModel.LastName]: chanichData.lastName,
              },
            };
            this.router.navigate(["/brothers"], ext).then((r) => r);
            return;
          }
          this.locationManageService.reload();
        },
        (reason) => {
          this.locationManageService.reload();
        }
      );
    } catch (err) {
      this.locationManageService.reload();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/child/createchild.component.ts